import './prototype';
export { default as create } from './create';
export { default as eventTargetManager } from './eventTargetManager';
export { default as trigger } from './trigger';
export * from './utils';
